import { render } from "./WindProducerView.vue?vue&type=template&id=38cb5248&scoped=true"
import script from "./WindProducerView.vue?vue&type=script&lang=js"
export * from "./WindProducerView.vue?vue&type=script&lang=js"

import "./WindProducerView.vue?vue&type=style&index=0&id=38cb5248&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38cb5248"]])

export default __exports__